import _cloneDeep from 'lodash/cloneDeep';

export default {
  attachment: (state) => _cloneDeep(state.attachment),
  attachments: (state) => _cloneDeep(state.attachments),
};
